function pathJoin(prefix, suffix) {
    var joiner = prefix.substr(prefix.length - 1, 1) == '/' ? '' : '/';
    return prefix + joiner + suffix;
}